import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import AnimatedLogo from "./elements/AnimatedLogo";
import ThemeXmas from "./themes/ThemeXmas";
import ThemeNewyear from "./themes/ThemeNewyear";
import ThemeSummer from "./themes/ThemeSummer";
import ThemeAutumn from "./themes/ThemeAutumn";
import ThemeHalloween from "./themes/ThemeHalloween";
import ThemeDefault from "./themes/ThemeDefault";

const THEMES = ["default", "newyear", "summer", "autumn", "halloween", "xmas"];


const getTitleText = (pathname: string) => {
  switch (pathname) {
    case "/":
      return "QR Cook";
    case "/qr-multiple":
      return "QRs Cook";
    case "/data-matrix":
      return "D.Matrix Cook";
    case "/barcode":
      return "Barcode Cook";
    default:
      return "QR Cook";
  }
};

function Navigation() {
  const location = useLocation();
  const [currentTheme, setCurrentTheme] = useState(THEMES[0]); // Default

  useEffect(() => {
    // Initial theme set based on month
    const month = new Date().getMonth() + 1; // 1-12
    if (month >= 1 && month <= 2) {
      setCurrentTheme("newyear");
    } else if (month >= 4 && month <= 6) {
      setCurrentTheme("summer");
    } else if (month >= 7 && month <= 9) {
      setCurrentTheme("autumn");
    } else if (month === 10) {
      setCurrentTheme("halloween");
    } else if (month >= 11 && month <= 12) {
      setCurrentTheme("xmas");
    } else {
      setCurrentTheme("default");
    }
  }, []);

  // Get title based on current route
  const getTitle = () => {
    switch (location.pathname) {
      case "/":
        return "QR Cook";
      case "/qr-multiple":
        return "QRs Cook";
      case "/data-matrix":
        return <small style={{ fontSize: "90%" }}>D.Matrix Cook</small>;
      case "/barcode":
        return <small style={{ fontSize: "90%" }}>Barcode Cook</small>;
      default:
        return "QR Cook";
    }
  };

  useEffect(() => {
    document.title = getTitleText(location.pathname);
  }, [location.pathname]);

  const headerContent = (
    <h1 className="d-flex gap-3 align-items-center justify-content-center">
      <AnimatedLogo
        alt={getTitleText(location.pathname)}
        width={54}
        height={54}
      />
      <span>{getTitle()}</span>
    </h1>
  );


  /* Theme Selector Logic */
  const handleThemeSwitch = () => {
    const currentIndex = THEMES.indexOf(currentTheme);
    const nextIndex = (currentIndex + 1) % THEMES.length;
    setCurrentTheme(THEMES[nextIndex]);
  };

  const renderTitleTheme = () => {
    switch (currentTheme) {
      case "xmas":
        return <ThemeXmas>{headerContent}</ThemeXmas>;
      case "newyear":
        return <ThemeNewyear>{headerContent}</ThemeNewyear>;
      case "summer":
        return <ThemeSummer>{headerContent}</ThemeSummer>;
      case "autumn":
        return <ThemeAutumn>{headerContent}</ThemeAutumn>;
      case "halloween":
        return <ThemeHalloween>{headerContent}</ThemeHalloween>;
      default:
        return <ThemeDefault>{headerContent}</ThemeDefault>;
    }
  };

  const renderThemeMenu = () => (
    <div className="theme-menu-container">
      <button className="theme-menu-btn" onClick={handleThemeSwitch} title="Switch Theme">
        {/* Switch Icon (Two Arrows) */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
        </svg>
      </button>
    </div>
  );

  return (
    <div className="row">
      <div className="col-12">
        <div className="nav-box">
          <div className="nav-header">
            <Link
              to="/"
              className={`nav-link ${location.pathname === "/" ? "nav-link-active" : ""
                }`}
            >
              QR Cook
            </Link>
            <Link
              to="/qr-multiple"
              className={`nav-link ${location.pathname === "/qr-multiple" ? "nav-link-active" : ""
                }`}
            >
              QRs Cook
            </Link>
            <Link
              to="/data-matrix"
              className={`nav-link ${location.pathname === "/data-matrix" ? "nav-link-active" : ""
                }`}
            >
              D.Matrix
            </Link>
            <Link
              to="/barcode"
              className={`nav-link ${location.pathname === "/barcode" ? "nav-link-active" : ""
                }`}
            >
              Barcode
            </Link>
          </div>
          <div className="nav-body z-index-1">
            {renderTitleTheme()}
            {renderThemeMenu()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navigation;
